// extracted by mini-css-extract-plugin
export default {"seoArticle":"SeoArticle_seoArticle__FHmh5","article":"SeoArticle_article__k4PvO","title":"SeoArticle_title__uoFQJ","content":"SeoArticle_content__O3w2c"};